import { render } from "./PaymentInfoSection.vue?vue&type=template&id=13bfe614"
import script from "./PaymentInfoSection.vue?vue&type=script&lang=js"
export * from "./PaymentInfoSection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__